/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import { PiccolaComposableBannerRenderer } from './PiccolaComposableBannerRenderer';
import { PiccolaComposableBanner } from './PiccolaComposableBanner';

const { string: stringType, shape: shapeType } = proptypes;

const PiccolaComposableBannerPreview = ({ componentId, componentClass = '', livePreviewData = null }) => {
  return (
    livePreviewData ? (
      <PiccolaComposableBannerRenderer
        data={livePreviewData}
        componentId={componentId}
        componentClass={componentClass}
      />
    ) : (
      <PiccolaComposableBanner
        componentId={componentId}
        componentClass={componentClass}
      />
    )
  );
};

PiccolaComposableBannerPreview.propTypes = {
  componentClass: stringType,
  componentId: stringType.isRequired,
  livePreviewData: shapeType({})
};

PiccolaComposableBannerPreview.displayName = 'PiccolaComposableBannerPreview';

export { PiccolaComposableBannerPreview };
